module.exports = __webpack_public_path__ + "static/img/info3.63b1a96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/pic/info3.jpg
// module id = pY21
// module chunks = 11